<div class="ticket-delivery">
  <p class="type">
    <i class="fa fa-ticket" aria-hidden="true"></i>
    {{ title }}
  </p>
  <ng-content></ng-content>
</div>
